module.exports = __webpack_public_path__ + "static/img/场馆展示1.25fe2ce3.png";